module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/998f2c842151641acf4fa126afb87de3.png";